import * as wizeMobileApi from '@wize-mobile-api';
import { ExchangeRates } from '@qvs/core';

export class ExchangeRatesMapper {
  public static fromWizeExchangeRatesToExchangeRates(exchangeRates: wizeMobileApi.ExchangeRates): ExchangeRates {
    const rates: ExchangeRates = {};
    if (exchangeRates?.exchangeRateRefCurrency && exchangeRates?.exchangeRates) {
      rates[exchangeRates.exchangeRateRefCurrency.id] = {};
      exchangeRates.exchangeRates.forEach((rate) => {
        rates[exchangeRates.exchangeRateRefCurrency.id][rate.currency.id] = rate.unitExchangeRate;
      });
    }
    return rates;
  }
}
